/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Try_AgainInputs */

const en_auth_error_try_again = /** @type {(inputs: Auth_Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try again`)
};

const es_auth_error_try_again = /** @type {(inputs: Auth_Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentalo de nuevo`)
};

/**
* | output |
* | --- |
* | "Please try again" |
*
* @param {Auth_Error_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_error_try_again = /** @type {((inputs?: Auth_Error_Try_AgainInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Try_AgainInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_error_try_again(inputs)
	return es_auth_error_try_again(inputs)
});